import React, { useContext, useState } from "react";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import { Link } from "react-router-dom";
import { GlobalTheme, TileTheme } from "../../layouts/theme";
import { Context } from "../contexts/siteContext.js";
import { Snackbar } from "@material-ui/core";
import { Theme } from "../contexts/themeContext.js";
import MuiAlert from '@material-ui/lab/Alert';
import CardContent from '@material-ui/core/CardContent';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function TeamProChart(props) {
    const tileClasses = TileTheme();
    const { theme } = useContext(Theme);
    const { defaultSite } = useContext(Context);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const currentTheme = GlobalTheme[theme];

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const linkClicked = (e) => {
        if (defaultSite.IntegratedSystem.TaskMGMTSystemId === null || defaultSite.IntegratedSystem.TaskMGMTSystemId === "0") {
            e.preventDefault();
            setErrorMessage("The Site " + defaultSite.name + " has not been setup to access TeamPRO.");
            setOpenError(true);
        }
        else if (sessionStorage.getItem("isOffline") === "1") {
            e.preventDefault();
            setErrorMessage("TeamPRO cannot be accessible in offline mode. Please connect to the internet.");
            setOpenError(true);
        }
    }
    
    return (<>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <Link to={{ pathname: "/teamProList" }} onClick={(e) => linkClicked(e)}>
            <Card chart color="primary" className={tileClasses.cardLow} style={{ background: currentTheme.background, color: currentTheme.text,marginBottom:'0px' }} >
                <CardContent className={tileClasses.cardContent}>
                    <CardHeader>
                        <div className={tileClasses.title}>TeamPro</div>
                    </CardHeader>
                </CardContent>
            </Card>
        </Link>
    </>
    );
}